import { cva as e } from "class-variance-authority";
// src/design/tooltip/styles.ts
var t = e([
	"z-tooltip rounded border shadow-floating backdrop-blur-sm",
	"dark:shadow-black/50",
	"animate-in fade-in-0 zoom-in-95 duration-fast",
	"data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
	"data-[side=bottom]:slide-in-from-top-1",
	"data-[side=left]:slide-in-from-right-1",
	"data-[side=right]:slide-in-from-left-1",
	"data-[side=top]:slide-in-from-bottom-1"
], {
	variants: {
		variant: {
			default: ["bg-inverse text-inverse-foreground border-inverse", ""],
			accent: "bg-primary text-primary-foreground border-primary",
			success: "bg-success text-success-foreground border-success",
			warning: "bg-warning text-warning-foreground border-warning",
			danger: "bg-destructive text-destructive-foreground border-destructive"
		},
		size: {
			sm: "px-1.5 py-0.5 text-xs",
			md: "px-2 py-1 text-xs",
			lg: "px-2.5 py-1.5 text-sm"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "md"
	}
}), n = e("[--arrow-size:8px]!", {
	variants: { variant: {
		default: ["[--arrow-background:var(--color-inverse)]!", "dark:[--arrow-background:var(--color-slate-100)]!"],
		accent: "[--arrow-background:var(--color-primary)]!",
		success: "[--arrow-background:var(--color-success)]!",
		warning: "[--arrow-background:var(--color-warning)]!",
		danger: "[--arrow-background:var(--color-destructive)]!"
	} },
	defaultVariants: { variant: "default" }
}), r = {
	gutter: 8,
	offset: {
		mainAxis: 0,
		crossAxis: 0
	},
	flip: !0,
	sameWidth: !1,
	fitViewport: !0
};
export { n as tooltipArrowStyles, t as tooltipContentStyles, r as tooltipPositioningDefaults };

//# sourceMappingURL=styles.js.map